module.exports = __webpack_public_path__ + "static/img/pingjie2.ae169ece.png";